import * as React from "react";
import { PageProps } from "../Page";
import { IEvaluationPresenter } from "../../../presenter/evaluation/EvaluationPresenter";
import DataGrid from "../../components/app/grid/DataGrid";
import EvaluationReviewRuleGroupsGrid from "../../components/evaluation/EvaluationReviewRuleGroupsGrid";

export interface Props extends PageProps {}
export interface State extends IEvaluationPresenter {}

export default class EvaluationPage extends React.Component<Props, State> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState(() => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      evaluationReviews,
      translate,
      onReviewExpand,
      evaluationRuleGroups,
      onRuleGroupExpand,
      evaluationBusinessRules
    } = this.state;

    const {
      evaluationRuleGroupsLoader,
      evaluationBusinessRuleLoader
    } = this.state.loaders;

    const columns = [
      {
        title: translate("evaluation_page.review_type_name"),
        dataIndex: "reviewTypeName",
        key: "reviewTypeName"
      }
    ];

    const expandedRowRender = (e) => {
      return (
        <EvaluationReviewRuleGroupsGrid
          translate={translate}
          evaluationRuleGroups={evaluationRuleGroups}
          isLoading={evaluationRuleGroupsLoader}
          onRuleGroupExpand={onRuleGroupExpand}
          evaluationBusinessRules={evaluationBusinessRules}
          evaluationBusinessRuleLoader={evaluationBusinessRuleLoader}
        />
      );
    };

    return (
      <DataGrid
        title={translate("evaluation_page.evaluations")}
        translate={translate}
        columns={columns}
        dataSource={evaluationReviews}
        expandedRowRender={expandedRowRender}
        onExpand={onReviewExpand}
        singleRowExpandEnabled
      />
    );
  }
}
